<template>
  <v-dialog v-model="show" scrollable v-bind="_attributes">
    <v-card>
      <Toolbar
        title="Dokumentum megtekintése"
        :show-btn="false"
        @close="close"
      />

      <v-card-text class="pt-3">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Dokumentum címe"
                :value="document.title"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Rövidítés"
                :value="document.abridgment"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Feltöltötte"
                :value="document.created_by"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Évszám"
                :value="document.year"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Sorszám"
                :value="document.serial_number"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Kibocsátó"
                :value="document.issuer.name"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Hatályba lépés"
                :value="_formattedDate(document.effective_date)"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Hatályon kívül helyezés"
                :value="
                (document.valid_until_revoked)
                ? 'Visszavonásig hatályos'
                : _formattedDate(document.date_of_repeal)"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Létrehozva"
                :value="document.created_at"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Utoljára frissítve"
                :value="document.updated_at"
                v-bind="inputAttributes"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row
            v-show="
              Object.keys(document).includes('files') &&
                document.files.length > 0
            "
          >
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col v-for="file in document.attached_files" :key="file.id">
              <v-list-item link target="_blank" :href="file.path">
                <v-list-item-icon>
                  <v-icon>
                    mdi-download-outline
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  {{ file.file_name }}
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <template v-if="_show(document)">
            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <h1>Meta Adatok</h1>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-for="meta in document.metas"
                :key="meta.slug"
              >
                <v-text-field
                  :label="meta.name"
                  :value="meta.pivot.value"
                  v-bind="inputAttributes"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
            <v-row v-if="_hasHistory">
              <v-col cols="12">
                <h2>Dokumentum változatok</h2>
              </v-col>
              <v-col cols="12" v-if="document.history.subsequent">
                <h3>Folyományok</h3>
              </v-col>
              <DocumentVariants
                :document="document.history.subsequent ? document.history.subsequent:[]"
                :effective_date="document.effective_date"
                relation="child"
              ></DocumentVariants>
              <v-col cols="12" v-if="document.history.precedent">
                <h3>Előzmények</h3>
              </v-col>
              <DocumentVariants
                :document="document.history.precedent ? document.history.precedent:[]"
                :effective_date="document.effective_date"
                relation="parent"
              ></DocumentVariants>
            </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { RESET } from "../../../utils/constants";
import DocumentVariants from '../../../components/Documents/Modals/DocumentVariants'
export default {
  name: "PublicDocumentModal",
  components: { DocumentVariants },
  computed: {
    ...mapGetters("Modal", {show: "showModal"}),
    ...mapGetters("Document", ["document"]),
    _attributes() {
      return this.$vuetify.breakpoint.mobile
        ? {
            fullscreen: true,
            hideOverlay: true,
            transition: "dialog-bottom-transition"
          }
        : {
            width: "50%",
            persistent: true
          };
    },
    _show() {
      return doc => doc.metas && doc.metas.length > 0;
    },
    _formattedDate() {
      return date => {
        return Vue.moment(date).format("YYYY.MM.DD");
      };
    },
    _hasHistory () {
      if (!this.document.history || !Object.keys(this.document.history)) {
        return false
      }

      if (this.document.history.subsequent && Object.keys(this.document.history.subsequent)) {
        return true
      }
      if (this.document.history.precedent && Object.keys(this.document.history.precedent)) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      inputAttributes: {
        readonly: true,
        outlined: true,
        hideDetails: true
      }
    };
  },
  methods: {
    ...mapActions("Modal", ['reset']),
    close(){
        this.reset();
        this.$emit('modalClosed');
    },
  }
};
</script>

<style></style>
